import React from "react";

const Smartphone = () => (
  <svg className="smartphone-icon" viewBox="0 0 46 80">
    <title>Asset 1</title>
    <g id="Layer_2" data-name="Layer 2">
      <g id="Layer_1-2" data-name="Layer 1">
        <path
          className="cls-1"
          d="M36,0H10A10,10,0,0,0,0,10V70A10,10,0,0,0,10,80H36A10,10,0,0,0,46,70V10A10,10,0,0,0,36,0ZM10,4H36a6,6,0,0,1,6,6v3H4V10A6,6,0,0,1,10,4ZM42,17V54H4V17ZM36,76H10a6,6,0,0,1-6-6V58H42V70A6,6,0,0,1,36,76Z"
        />
        <path className="cls-1" d="M28,65H18a2,2,0,0,0,0,4H28a2,2,0,0,0,0-4Z" />
      </g>
    </g>
  </svg>
);

export default Smartphone;
